/* eslint-disable */
import { Component, Injector } from '@angular/core';
import { BaseRoute } from '../../../shared/components/base.route';

@Component({
  selector: 'financial-info',
  template: require('./financial-info.component.html'),
})
export class FinancialInfoComponent extends BaseRoute {
  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit() {
    const appType = this.appActions.getData('appType');
    const steps = this.flowManager.getStepArrays('financial-info');
    this.form.stepsComplete = steps.stepsComplete;
    this.form.stepsToComplete = steps.stepsToComplete;

    this.form.buttons.inputs.next.path = `/${this.form.stepsToComplete[0].route}`;

    if (appType === 'tka') {
      this.form.inputs.htmlTradingExperience.showUp = false;
      this.form.inputs.securitiesExperience.showUp = false;
      this.appActions.setData('FinancialInformation.isExperienced', false);
    }
  }

  updateOptionValue(event) {
    // console.log('Form Route', event);
  }
}
